import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminViewsComponent } from './admin-views.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { AvatarModule } from '@app/shared/components/avatar/avatar.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Route, RouterModule } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { DemoInputCheckboxRadioComponent } from '@app/views/form-elements/input/demos/checkbox-radio/checkbox-radio';
import { RadioComponent } from '@app/shared/components/radio/radio.component';
import { DemoRadioBasicComponent } from '@app/views/form-elements/radio/demos/basic/basic';
import { DemoRadioDisabledComponent } from '@app/views/form-elements/radio/demos/disabled/disabled';
import { DemoRadioInlineComponent } from '@app/views/form-elements/radio/demos/inline/inline';
import { DemoRadioWithFormComponent } from '@app/views/form-elements/radio/demos/withForm/withForm';
import { RadioModule } from '@app/shared/components/radio/radio.module';
import { CheckboxModule } from '@app/shared/components/checkbox/checkbox.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { EditManufacturersComponent } from './edit-manufacturers/edit-manufacturers.component';
import { SharedModule } from '@app/shared/shared.module';
export const tasksRoutes: Route[] = [
  {
    path: '',
    component: UsersComponent
}
]

@NgModule({
  declarations: [
    AdminViewsComponent,
    UsersComponent,
    EditManufacturersComponent
  ],
  imports: [
    CheckboxModule,
    RouterModule.forChild(tasksRoutes),
    TranslateModule.forRoot({

    }),
    SharedModule,
    NgApexchartsModule,
    ProgressbarModule,
    AvatarModule,
    PerfectScrollbarModule,
    BsDatepickerModule.forRoot(),
  ]
})
export class AdminViewsModule { }
